import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken, logUserOut } from '../utils/login';
// Types.
import { Ledger } from '../types/billing';

export const fetchLedgers = async (dataOwnerCustomerId: number, actingCustomerId: number): Promise<Ledger[]> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  if (bearer) {
    const ledgerRequest: AxiosResponse<Ledger[]> | undefined = await API({
      method: 'post',
      url: `/v1/ledgers/${dataOwnerCustomerId}/${actingCustomerId}`,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
      data: {
        authUser: actingCustomerId,
      },
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          logUserOut();
        }
        return error.response;
      }
    });

    // On any error path (including the 401 case above), `ledgerRequest` may be the raw
    // error response (or undefined for a network-level failure with no response at all).
    // In both cases `.data` will not be a Ledger[]. Guard here so callers always get an
    // array matching the declared return type, instead of an arbitrary error body that
    // later crashes with "<x>.filter/find/map is not a function" wherever it's consumed.
    return Array.isArray(ledgerRequest?.data) ? ledgerRequest.data : [];
  }
  return [];
};
